import { ExpandLessOutlined, ExpandMoreOutlined } from '@mui/icons-material';
import { Collapse, Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '@/legacy/common/types';

import { Root, ButtonContent, ButtonStyled } from './ExpandButton.styled';

interface ExpandButtonProps {
  isExpanded: boolean;
  expandMoreTitle?: string;
  expandLessTitle?: string;
  onToggle: () => void;
}

export const ExpandButton = ({ isExpanded, expandMoreTitle, expandLessTitle, onToggle }: ExpandButtonProps) => {
  const theme = useTheme();
  const { t } = useTranslation(I18nNamespace.common, { keyPrefix: 'ListExpandToggle' });
  expandMoreTitle = expandMoreTitle || t('showMore');
  expandLessTitle = expandLessTitle || t('showLess');
  const [showTitle, setShowTitle] = useState<boolean>(false);

  return (
    <Root>
      <ButtonStyled onClick={onToggle} onMouseEnter={() => setShowTitle(true)} onMouseLeave={() => setShowTitle(false)}>
        {isExpanded ? (
          <ButtonContent>
            <Collapse in={showTitle} orientation="horizontal">
              <Typography variant="button">{expandLessTitle}</Typography>
            </Collapse>
            <ExpandLessOutlined sx={showTitle ? undefined : { color: theme.palette.grey[400] }} fontSize="small" />
          </ButtonContent>
        ) : (
          <ButtonContent>
            <Collapse in={showTitle} orientation="horizontal">
              <Typography variant="button">{expandMoreTitle}</Typography>
            </Collapse>
            <ExpandMoreOutlined sx={showTitle ? undefined : { color: theme.palette.grey[400] }} fontSize="small" />
          </ButtonContent>
        )}
      </ButtonStyled>
    </Root>
  );
};
